import { render, staticRenderFns } from "./PairDevice.vue?vue&type=template&id=565b43c8&"
import script from "./PairDevice.vue?vue&type=script&lang=js&"
export * from "./PairDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports